// This file was autogenerated from /frontend/sail-next/packages/docs/src/examples/Icon/ButtonWithIcon.story.tsx with go/sail-next-tailor-docs-publisher

import React from 'react';
import {Badge, Button, Icon, view, css} from '@sail/ui';
import {mobile} from '@sail/icons/react/DeviceIcon';

export const ButtonWithIcon = () => (
  <>
    <Button>
      <view.div css={{layout: 'row', gap: 75, alignY: 'center'}}>
        <Icon icon={mobile} size="xsmall" />
        <view.span>New messages</view.span>
      </view.div>
    </Button>
    <Badge type="positive">
      <Icon icon={mobile} size="xsmall" />
      New messages
    </Badge>
  </>
);
